import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { Pill } from "lucide-react";
import { api, PROFILE_KEY } from "@/lib/api";
import { Input } from "@/components/ui/input";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      localStorage.removeItem(PROFILE_KEY);
      window.location.href = "/day";
    } catch (e) {
      const d = e?.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Could not reset the password");
      setBusy(false);
    }
  };

  return (
    <div className="grain relative min-h-screen bg-[#0B1120] text-slate-100">
      <div className="aurora" />
      <div className="relative z-10 mx-auto flex min-h-screen max-w-md flex-col justify-center px-7">
        <div className="rise mb-8 flex flex-col items-center">
          <div className="flex h-14 w-14 items-center justify-center rounded-2xl border border-sky-500/30 bg-sky-500/10">
            <Pill className="h-6 w-6 text-sky-300" />
          </div>
          <h1 className="mt-4 text-2xl font-bold tracking-tight">Choose a new password</h1>
        </div>
        <Input
          data-testid="new-password-input"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="New password (min 8 characters)"
          className="h-13 rounded-xl border-slate-800 bg-slate-900/70 px-4 py-3.5 text-[16px]"
        />
        <button
          data-testid="reset-submit-btn"
          disabled={busy}
          onClick={submit}
          className="mt-3 h-14 w-full rounded-full bg-gradient-to-r from-sky-500 to-blue-600 text-[17px] font-semibold text-white disabled:opacity-50 active:scale-95"
        >
          Save password
        </button>
      </div>
    </div>
  );
}
